// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import React from 'react';
import type { Icon } from 'iconsax-react';

const FilePngIcon: Icon = ({ size = 24, color, variant: _variant, className, style, ...rest }) => {
  const id = React.useId();
  const clipId = `${id}-clip`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...rest}
    >
      <g clipPath={`url(#${clipId})`}>
        <path d="M19 11C19 10.182 19 9.43 18.848 9.063C18.696 8.696 18.407 8.406 17.828 7.828L13.092 3.092C12.593 2.593 12.344 2.344 12.034 2.196C11.9698 2.16518 11.9041 2.13781 11.837 2.114C11.514 2 11.161 2 10.456 2C7.211 2 5.588 2 4.489 2.886C4.26709 3.06494 4.06494 3.26709 3.886 3.489C3 4.59 3 6.211 3 9.456V14C3 17.771 3 19.657 4.172 20.828C5.344 21.999 7.229 22 11 22H19M12 2.5V3C12 5.828 12 7.243 12.879 8.121C13.757 9 15.172 9 18 9H18.5" stroke={color || '#141414'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7 19V17M7 17V14H8.5C8.89782 14 9.27936 14.158 9.56066 14.4393C9.84196 14.7206 10 15.1022 10 15.5C10 15.8978 9.84196 16.2794 9.56066 16.5607C9.27936 16.842 8.89782 17 8.5 17H7ZM21 15C21 14.7348 20.8946 14.4804 20.7071 14.2929C20.5196 14.1054 20.2652 14 20 14H19C18.7348 14 18.4804 14.1054 18.2929 14.2929C18.1054 14.4804 18 14.7348 18 15V18C18 18.2652 18.1054 18.5196 18.2929 18.7071C18.4804 18.8946 18.7348 19 19 19H20C20.2652 19 20.5196 18.8946 20.7071 18.7071C20.8946 18.5196 21 18.2652 21 18V17H20M12 19V14L15.5 19V14" stroke={color || '#141414'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { FilePngIcon };
